import { render, staticRenderFns } from "./InstanceActionSnackbar.vue?vue&type=template&id=60cdd473&scoped=true"
import script from "./InstanceActionSnackbar.vue?vue&type=script&lang=js"
export * from "./InstanceActionSnackbar.vue?vue&type=script&lang=js"
import style0 from "./InstanceActionSnackbar.vue?vue&type=style&index=0&id=60cdd473&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cdd473",
  null
  
)

export default component.exports